export default "__VITE_ASSET__187735ef__"